import type { ReactElement, ReactNode } from "react";
import MarkerClusterGroup from "react-leaflet-markercluster";

const markerClusterOptions = {
    animateAddingMarkers: false,
    spiderfyOnMaxZoom: false,
    chunkedLoading: true,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: false,
    disableClusteringAtZoom: false,
};

/**
 * Props for the LegendCluster component.
 */
interface LegendClusterProps {
    /**
     * The legend markers to cluster.
     */
    children: ReactElement[];
    /**
     * Whether the cluster is rendered at the current zoom level.
     */
    visible: boolean;
}

/**
 * Clusters the zoom-gated legend overlays rendered above the lights.
 *
 * @param {LegendClusterProps} props - The props for the LegendCluster component.
 * @returns {ReactNode} The rendered LegendCluster component.
 */
const LegendCluster = ({ children, visible }: LegendClusterProps): ReactNode =>
    visible ? (
        <MarkerClusterGroup {...markerClusterOptions}>
            {children}
        </MarkerClusterGroup>
    ) : null;

export { LegendCluster };
